// extracted by mini-css-extract-plugin
module.exports = {"RoutesSimpleSection":"RoutesSimpleSection_RoutesSimpleSection__xHMpi","Grid":"RoutesSimpleSection_Grid__6rqe9"};